<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-3">
                <div class="float-right">
                    <div class="btn-group shadow-sm">
                        <button class="btn btn-sm btn-default border-0" v-for="interval in periods"
                            :key="interval.value" :class="{'bg-primary text-white': interval.active}"
                            @click="changeInterval(interval)">{{ interval.value | capitalize }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <trending-over-time-interval
            class="mb-4"
            type="nps"
            :max-overall="100"
            :trendingOverTimeInterval="trendingOverTime"
            :loading="loading"
        />

        <div class="row">
            <div class="col-md-6 col-lg-5 mb-4 widget">
                <overall-score-widget class="h-100" type="nps"/>
            </div>
            <div class="col-md-6 col-lg-7 mb-4 widget">
                <nps-overview-widget :npsOverview="npsOverview" :loading="loading"/>
            </div>
        </div>

        <invites-overview-widget-interval
            class="mb-4"
            :invitesOverview="invitesOverview"
            :loading="loading"
        />

        <recent-reviews-widget type="nps" />
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data: () => ({
            periods         : [
                {value: 'daily', active: false},
                {value: 'weekly', active: false},
                {value: 'monthly', active: true},
                {value: 'all time', active: false},
            ],
            periodSelected  : 'monthly',
            trendingOverTime: [],
            npsOverview     : null,
            invitesOverview : null,
            loading         : true
        }),

        async created() {
            this.loading = true;
            await this.$http.all([
                this.fetchTrendingOverTimeData(),
                this.fetchNpsOverview(),
                this.fetchInvitesOverview()
            ])
                .then(this.$http.spread((trendingOverTime, npsOverview, invitesOverview) => {
                    this.trendingOverTime = trendingOverTime.data;
                    this.npsOverview      = npsOverview.data;
                    this.invitesOverview  = invitesOverview.data;
                }))
                .then(() => this.loading = false);
        },

        computed: {
            ...mapState({filter: state => state.filter})
        },

        watch: {
            filter() {
                this.fetchAll(this.periodSelected);
            },
        },

        methods: {
            fetchTrendingOverTimeData(value = 'monthly') {
                const params = {...this.filter, type: 'nps', interval: value};
                return this.$http
                    .get(this.$laroute.route('api.reviews.trending-over-time'), {params});
            },

            fetchNpsOverview(value = 'monthly') {
                const params = {...this.filter, interval: value};
                return this.$http.get(this.$laroute.route('api.reviews.nps-overview'), {params});
            },

            fetchInvitesOverview(value = 'monthly') {
                const params = {...this.filter, type: 'nps', interval: value};
                return this.$http.get(this.$laroute.route('api.invites.overview'), {params});
            },

            changeInterval(interval) {
                if (interval.active) {
                    return;
                }
                this.periodSelected = interval.value;

                const toggleValue = true;
                this.loading      = true;
                this.disableActiveClass();
                interval.active = toggleValue;

                this.fetchAll(interval.value);
            },

            disableActiveClass() {
                for (let index in this.periods) {
                    if (this.periods.hasOwnProperty(index)) {
                        this.$set(this.periods[index], 'active', undefined);
                    }
                }
            },

            fetchAll(interval) {
                return Promise.all([
                    this.fetchInvitesOverview(interval),
                    this.fetchTrendingOverTimeData(interval),
                    this.fetchNpsOverview(interval)
                ]).then(res => {
                    this.invitesOverview  = res[0].data;
                    this.trendingOverTime = res[1].data;
                    this.npsOverview      = res[2].data;
                }).then(() => this.loading = false)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .widget {
        max-height: 277px;
    }
</style>
